import { createLazyComponent, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "GALRecipientWellModal" */ './lazyIndex')
);

export const GALRecipientWellModal = createLazyComponent(lazyModule, m => m.GALRecipientWellModal);
export const GALRecipientWellModalFromViewstate = createLazyComponent(
    lazyModule,
    m => m.GALRecipientWellModalFromViewstate
);
